import AuthLayout from "./AuthLayout";
import AuthMicrosoftPage from "./pages/AuthMicrosoftPage";

export const authRoutes = {
  path: "/auth",
  component: AuthLayout,
  children: [
    {
      path: "microsoft/redirect/:passport",
      name: "AuthMicrosoftPage",
      component: AuthMicrosoftPage
    },
  ]
}
